<!-- Base.ImagePreview.vue (client-lms) -->
<template>
  <div class="lms_image_preview" :style="{ width: width + 'px', height: height + 'px' }">
    <img :src="src" :alt="alt" />
    <button v-if="removable" type="button" class="lms_image_preview_remove" @click="$emit('remove')">
      <i class="mdi mdi-close"></i>
    </button>
  </div>
</template>

<script setup lang="ts">
defineProps({
  src: { type: String, required: true },
  alt: { type: String, default: "" },
  width: { type: Number, default: 320 },
  height: { type: Number, default: 176 },
  removable: { type: Boolean, default: true },
});

defineEmits<{ (e: "remove"): void }>();
</script>
